var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97065 0.972367C7.11151 0.838256 7.29897 0.764114 7.49346 0.765585C7.68796 0.767057 7.87427 0.844027 8.01309 0.980255C8.15191 1.11648 8.23239 1.30131 8.23753 1.49574C8.24267 1.69017 8.17208 1.87899 8.04065 2.02237L4.05065 7.01237C3.98204 7.08626 3.89923 7.14557 3.80718 7.18673C3.71513 7.2279 3.61572 7.25008 3.5149 7.25194C3.41408 7.25381 3.31392 7.23533 3.2204 7.1976C3.12689 7.15987 3.04194 7.10367 2.97065 7.03237L0.324646 4.38637C0.250959 4.3177 0.191857 4.2349 0.150865 4.1429C0.109873 4.05091 0.087831 3.95159 0.0860542 3.85089C0.0842774 3.75019 0.102802 3.65016 0.140523 3.55677C0.178244 3.46338 0.234389 3.37855 0.305608 3.30733C0.376826 3.23611 0.46166 3.17997 0.555048 3.14224C0.648436 3.10452 0.748466 3.086 0.849169 3.08777C0.949872 3.08955 1.04918 3.11159 1.14118 3.15259C1.23318 3.19358 1.31598 3.25268 1.38465 3.32637L3.47865 5.41937L6.95165 0.994367C6.9579 0.986668 6.96458 0.979323 6.97165 0.972367H6.97065Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.da9823d8e9c169ab3848a650555f66de.svg";
export { ForwardRef as ReactComponent };